import React from 'react';
import { isEqual } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';

import { naturalSort } from 'utils/sorting';

import ListBox from './ListBox';

const style = theme => ({
    wrapper: {
        display: 'flex',
    },

    leftList: {
        paddingRight: theme.spacing(),
    },
    rightList: {
        paddingLeft: theme.spacing(),
    },
});

const defaultProps = {
    initialValue: [],
    disabled: false,
    multiple: true,
};

const sortOptions = options => naturalSort(options, item => item.label);

class DualListBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.initialValue || [],
            options: sortOptions(props.options || []),
        };
    }

    componentWillReceiveProps(nextProps) {
        const { initialValue, options } = this.props;

        if (
            !isEqual(initialValue, nextProps.initialValue) ||
            !isEqual(options, nextProps.options)
        ) {
            this.setState({
                value: nextProps.initialValue || [],
                options: sortOptions(nextProps.options || []),
            });
        }
    }

    addSelectedValues = selectedValues => {
        const updatedValue = [...this.state.value, ...selectedValues];
        this.setState({ value: updatedValue }, () =>
            this.props.onChange(updatedValue)
        );
    };

    removeSelectedValues = selectedValues => {
        const { value } = this.state;
        const updatedValue = value.filter(
            valueItem => selectedValues.indexOf(valueItem) < 0
        );

        this.setState({ value: updatedValue }, () =>
            this.props.onChange(updatedValue)
        );
    };

    render() {
        const { disabled, multiple, classes, className } = this.props;

        const { options, value } = this.state;

        const optionsLeft = options.filter(
            option => value.indexOf(option.value) < 0
        );
        const optionsRight = options.filter(
            option => value.indexOf(option.value) !== -1
        );
        const disabledLeft = !multiple && optionsRight.length > 0;
        return (
            <div className={classNames(classes.wrapper, className)}>
                <ListBox
                    options={optionsLeft}
                    onTransfer={this.addSelectedValues}
                    buttonContent={<FastForwardIcon />}
                    disabled={disabled || disabledLeft}
                    headerName={this.props.sourceListHeaderName}
                    className={classes.leftList}
                />
                <ListBox
                    options={optionsRight}
                    onTransfer={this.removeSelectedValues}
                    buttonContent={<FastRewindIcon />}
                    disabled={disabled}
                    headerName={this.props.destinationListHeaderName}
                    className={classes.rightList}
                    error={this.props.destinationListError}
                />
            </div>
        );
    }
}

DualListBox.defaultProps = defaultProps;

export default withStyles(style)(DualListBox);
